(function ($) {

	$(document).ready(function() {
        
        /* AOS */
        AOS.init({
            duration: 400,
            once: true,
        });
        
        /* Object-fit polyfill run */
        objectFitImages();

        /* Jarallax */
        jarallax(document.querySelectorAll('.jarallax'));
        jarallax(document.querySelectorAll('.jarallax-keep-img'), {
            keepImg: true,
        });
        
        /* Global Modal Popup */
        $('.popup-modal').magnificPopup({
            type: 'inline',
            preloader: false
        });
        $(document).on('click', '.popup-modal-dismiss', function (e) {
            e.preventDefault();
            $.magnificPopup.close();
        });
        
	});
})(jQuery);